// DS: i5.3
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const FavStar: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path d="M18.189 4.414a1 1 0 00-.81-.414h-2.804l-.12.007a1 1 0 00-.754.506l-2.814 5.049-6.229.89-.124.027a1 1 0 00-.687.66l-.852 2.667-.03.122a1 1 0 00.29.904l4.469 4.285-1.05 6.052-.014.127a1 1 0 00.424.861l2.397 1.688.105.064a1 1 0 00.931.006l5.488-2.845 5.596 2.87.113.05a1 1 0 00.926-.127l2.34-1.677.098-.081a1 1 0 00.303-.91l-1.096-6.078 4.462-4.278.086-.094a1 1 0 00.17-.946l-.885-2.636-.047-.116a1 1 0 00-.76-.556l-6.238-.893-2.82-5.083-.064-.101zm-3.027 1.585h1.627l3.017 5.438 6.61.946.488 1.451-4.777 4.582 1.174 6.512-1.331.954L16 22.82l-5.865 3.038-1.382-.972 1.123-6.476-4.786-4.591.472-1.476 6.59-.942 3.01-5.402z" />
    </svg>
  </IconWrap>
);
FavStar.displayName = 'FavStar';

export default FavStar;
